export default __webpack_public_path__ + "media/images/logo_alt-17688638cb922aed605a2ce8edd6beef.svg";